<i18n lang='yml' src='../i18n/SubLocationIndex.yml'></i18n>
<template>
  <div>
    <div class="layout-tile">
      <div class="heading-block d-flex">
      <h4>
        {{ $t('header') }}
      </h4>
        <a v-if="edit_permission == 'true'" class="btn btn-sm btn-success ml-auto" :href="`sub_locations/new`">
          <font-awesome-icon :icon="['fas', 'plus']"/>
          {{ $t('add') }}
        </a>
      </div>
    </div>
    <filter-bar :filter_params = filter_params :filter_path = filter_path></filter-bar>
    <div class="media-list">
      <div class="content-block" v-for="item in subLocations" :key="item.id">
        <div class="post-meta">
          <ul class="list-inline list-annotation">
            <li>
              <h5 class="container-item-name">
                <a :href="`sub_locations/${item.id}/sittings`"> {{`${item.name[locale]}`}}  </a>
              </h5>
            </li>
            <li class="ml-auto" v-if="edit_permission == 'true'">
              <div class="btn-group btn-group-sm ml-auto" role="group">
                <a class="btn btn-outline-primary" :href="`${base_path}/${item.id}/edit`">
                  <font-awesome-icon :icon="['fas', 'edit']"/>
                  <span> {{ $t('edit') }} </span>
                </a>
              </div>
            </li>
          </ul>
        </div>
        <div class="post-meta">
          <ul class="list-unstyled list-inline list-annotation">
            <li class="list-inline-item"> 
              <span class="status-bold">{{$t('exam_location_id')}}</span>
              {{ item.sub_location_id}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">{{ $t('address') }}</span>
              {{ formattedAddress(item)}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">{{ $t('phone_number') }}</span>
              {{ item.phone_number}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">{{ $t('phone_number_extension') }}</span>
              {{ item.phone_number_extension ? item.phone_number_extension: "N/A"}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">{{ $t('email') }}</span>
              {{ item.email}}
            </li>
            <li class="list-inline-item">
              <span class="status-bold">{{ $t('status') }}</span>
              {{ $t(item.status)}}
            </li>
          </ul>
        </div>
      </div>

    </div>
    <div v-if="subLocations.length == 0">
      <div class="alert alert-warning" role="alert">
        {{ $t('no_data') }}
      </div>
    </div>
  </div>
</template>

<script>
  import Main from '../../filter_bar/components/Main.vue';

  export default {
    props: ['locale', 'filter_params', 'filter_path', 'base_path', 'sub_locations', 'edit_permission'],

    components: {
      'filter-bar': Main,
    },

    data() {
      return {
        subLocations: [],
        loading: false,
        error: false,
        filterParams: null,
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;

      this.filterParams = this.filter_params
      try {
        this.subLocations = JSON.parse(this.sub_locations) || [];
      }
      catch(err){
        this.error = true;
      }
    },
    methods: {
      formattedAddress(item) {
     
          return `${item['street_address']}, ${item['city']}, ${item['province']}, ${item['postal_code']}`
      }
    }
 }
</script>
